import type { FaireProductEntity } from "../../entity_types/product";

export const p_9w7bfyqpu6: FaireProductEntity = {
  token: "p_9w7bfyqpu6",
  type: "product",
  name: "Alpaca Socks",
  brandToken: "b_6djj84hu7k",
  brandName: "PERUVIAN PERFECTION",
  imageUrl:
    "https://cdn.faire.com/fastly/156a007df0c7510bb022729ed89e3b22092123afde2fa5bc06b0c9f0be8db865.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72dbb44aa874c0cae1ad3cce056a16fc283ce5dbfee2a72c6799fd41bc513622.jpeg",
    "https://cdn.faire.com/fastly/f4a3405035d987a3d31bbb659ecaf73b4d5878406ed35b5d75ae2b67f8eaeabb.jpeg",
    "https://cdn.faire.com/fastly/5c429196b0ed5339dee5156661b018c3ac2368eb5445d54ef634f9c83943c7c3.jpeg",
    "https://cdn.faire.com/fastly/e78c1e58ab09cad2adc6303c7f35fe75b8f2ad0ff21ffe549c4f4010e54655eb.jpeg",
    "https://cdn.faire.com/fastly/ec467709897ef7757b063a4aa49e88d0c59ba9277f256b962e8b6f2db4f05f1e.jpeg",
    "https://cdn.faire.com/fastly/0ddf10d4bf80a32832248d668feef3302aee6f3dd7742b19eb90a06c28114060.jpeg",
  ],
  priceDollars: 13.2,
  description:
    "Luxuriously Alpaca socks, naturally warm, breathable, and lightweight with a comfortable stretch fit. Perfect for everyday wear.\n\n𝟏𝐎𝐧𝐞 𝐒𝐢𝐳𝐞 𝐅𝐢𝐭𝐬 𝐀𝐥𝐥:\nOur alpaca socks are designed in one versatile size because the natural stretch of alpaca—enhanced with a touch of spandex, adapts comfortably to different foot shapes and sizes. This makes it easy to shop for yourself or as a gift, without the worry of choosing the wrong size. Soft, flexible, and breathable, alpaca socks naturally mold to your feet while staying warm and cozy.\n\n• Women's Shoe Size 7 to 11\n• Men's Show Size 6.5 to 10.5",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:29.508Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
